import { GenerateTheme } from "./themeConfig";
import { createMuiTheme } from "@material-ui/core/styles";

const clientName = process.env.REACT_APP_CLIENT_NAME;
const newTheme = GenerateTheme(clientName ? clientName : "NRC");
const theme = createMuiTheme({
	...newTheme,
});

export default theme;
